"use client";

import Link from "next/link";
import { useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { Logo } from "./logo";

const nav = [
  { label: "Kai", href: "#kai" },
  { label: "Platform", href: "#features" },
  { label: "MCP", href: "#mcp" },
  { label: "Customers", href: "#customers" },
  { label: "Pricing", href: "#pricing" },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border-subtle bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link href="/" className="flex items-center gap-3">
          <Logo />
          <span className="hidden items-center gap-1.5 rounded-full border border-accent/30 bg-accent/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-accent sm:flex">
            <Sparkles size={10} />
            by Profisea Labs
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {nav.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="text-sm text-muted transition-colors hover:text-foreground"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            href="#signin"
            className="text-sm text-muted transition-colors hover:text-foreground"
          >
            Sign In
          </Link>
          <Link
            href="#demo"
            className="rounded-full bg-foreground px-4 py-2 text-sm font-medium text-background transition-all hover:bg-muted"
          >
            Talk to Kai
          </Link>
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border-subtle bg-background md:hidden">
          <nav className="flex flex-col px-6 py-4">
            {nav.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="py-3 text-sm text-muted"
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="#demo"
              className="mt-2 rounded-full bg-foreground px-4 py-2 text-center text-sm font-medium text-background"
            >
              Talk to Kai
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
